module.exports = __webpack_public_path__ + "img/sm.6dfad41f.jpg";